if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form) {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      };
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const quantityMax = parseInt(document.querySelector('.quantity__input').getAttribute('max'));
      const inputQuantity = parseInt(document.querySelector('.quantity__input').value);
      const quantityMessageContainer = document.querySelector('#quantity-error');

      if (inputQuantity > quantityMax) {
        document.querySelector('.product-form__submit').disabled = true;

        if (quantityMessageContainer) {
          quantityMessageContainer.innerHTML = 'Quantity in cart cannot exceed available and incoming inventory.';
          quantityMessageContainer.classList.remove('hidden');
        }

        return;
      } else {
        document.querySelector('.product-form__submit').disabled = false;
        quantityMessageContainer.innerHTML = '';
        quantityMessageContainer.classList.add('hidden');
      }

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const quantityInput = document.querySelector('.product-form__quantity [name=quantity]');
      let formData = new FormData(this.form);
      let config = fetchConfig('javascript');
      let fetchUrl = routes.cart_add_url;

      if (quantityInput) {
        const minimumOrderQuantity = parseInt(quantityInput.dataset.moq);
        const quantitySelected = parseInt(quantityInput.value);
        const mainProductQuantityAvailable = parseInt(quantityInput.dataset.availableQty);
        const mainProductId = parseInt(this.form.querySelector('[name=id]').value);
        const customerID = document.body.dataset.cid;

        if (quantitySelected > mainProductQuantityAvailable) {
          const currentVariantSku = document.querySelector('input[name="sku"]').value;
          let inStockProductQuantity = mainProductQuantityAvailable;
          let preOrderStockQuantity = quantitySelected - mainProductQuantityAvailable;

          // calculate the quantity split when MOQ is involved
          // this takes into account the inventories after a variant has already been added to the cart
          if (mainProductQuantityAvailable == 0) {
            let preOrderQuantityToAdd = preOrderStockQuantity;

            if (minimumOrderQuantity > 1) {
              preOrderQuantityToAdd = 0;

              do {
                preOrderQuantityToAdd += minimumOrderQuantity;
              }
              while (preOrderQuantityToAdd < quantitySelected);
            }

            const preorderVariantSku = currentVariantSku.includes('PRE-') ? currentVariantSku : `PRE-${currentVariantSku}`;
            const variantPreorderInventoryQuantityObj = window.variantInventory[preorderVariantSku];

            // only add the preorder variant
            if (variantPreorderInventoryQuantityObj) {
              formData = {
                'items': [
                  {
                    'id': variantPreorderInventoryQuantityObj.variant_id,
                    'quantity': preOrderQuantityToAdd,
                    'properties': {
                      'Inventory': 'Backorder, Ships Later',
                      '_intuitive_cid': customerID
                    }
                  }
                ]
              };
              config = fetchConfig('json');
              fetchUrl = `${routes.cart_add_url}`;
              config.body = JSON.stringify(formData);
            }
          } else {
            let inStockQuantityToAdd = inStockProductQuantity;
            let preOrderQuantityToAdd = preOrderStockQuantity;

            if (minimumOrderQuantity > 1) {
              inStockQuantityToAdd = 0;
              preOrderQuantityToAdd = 0;

              do {
                inStockQuantityToAdd += minimumOrderQuantity;
              }
              while (inStockQuantityToAdd < inStockProductQuantity);

              const quantityRemaining = quantitySelected - inStockQuantityToAdd;

              do {
                preOrderQuantityToAdd += minimumOrderQuantity;
              }
              while (preOrderQuantityToAdd < quantityRemaining);
            }

            const preorderVariantSku = currentVariantSku.includes('PRE-') ? currentVariantSku : `PRE-${currentVariantSku}`;
            const variantPreorderInventoryQuantityObj = window.variantInventory[preorderVariantSku];

            if (variantPreorderInventoryQuantityObj) {
              formData = {
                'items': [
                  {
                    'id': mainProductId,
                    'quantity': inStockQuantityToAdd,
                    'properties': {
                      'Inventory': 'In-stock',
                      '_intuitive_cid': customerID
                    }
                  },
                  {
                    'id': variantPreorderInventoryQuantityObj.variant_id,
                    'quantity': preOrderQuantityToAdd,
                    'properties': {
                      'Inventory': 'Backorder, Ships Later',
                      '_intuitive_cid': customerID
                    }
                  }
                ]
              };
              config = fetchConfig('json');
              fetchUrl = `${routes.cart_add_url}`;
              config.body = JSON.stringify(formData);
            }
          }
        } else {
          formData = {
            'items': [
              {
                'id': mainProductId,
                'quantity': quantitySelected,
                'properties': {
                  'Inventory': 'In-stock',
                  '_intuitive_cid': customerID
                }
              }
            ]
          };
          config = fetchConfig('json');
          fetchUrl = `${routes.cart_add_url}`;
          config.body = JSON.stringify(formData);
        }
      }

      fetch(`${fetchUrl}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
